module.exports = __webpack_public_path__ + "static/media/sign_out_top_navbar_icon.a911962e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign_out_top_navbar_icon.svg
// module id = 443
// module chunks = 1